module.exports = __webpack_public_path__ + "static/media/screen1.3e63bc3b.png";